import React from 'react'
import { MagnifyingGlass, X } from '@phosphor-icons/react'
import css from './SearchInput.module.css'

type Props = {
  value: string
  onChange: (value: string) => void
  placeholder: string
}

/** Compact search field with a clear button. Escape clears it too */
const SearchInput = ({ value, onChange, placeholder }: Props) => (
  <div className={css['search']}>
    <MagnifyingGlass
      size={14}
      weight="bold"
      className={css['icon']}
      aria-hidden
    />
    <input
      type="search"
      className={css['input']}
      value={value}
      placeholder={placeholder}
      aria-label={placeholder}
      onChange={(e) => onChange(e.target.value)}
      onKeyDown={(e) => {
        if (e.key === 'Escape') onChange('')
      }}
    />
    {value && (
      <button
        type="button"
        className={css['clear']}
        aria-label="Clear search"
        onClick={() => onChange('')}
      >
        <X size={12} weight="bold" aria-hidden />
      </button>
    )}
  </div>
)

export default SearchInput
